<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Create Collection" @close="close()" />

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea outlined :error-messages="nameErrors" :hide-details="nameErrors.length === 0" autofocus dense
              auto-grow v-model="message" label="Message"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import paymentService from "@/modules/Donors/PaymentInfoCollect/service.js";
import GlobalFunction from "@/mixins/GlobalFunction";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false,
    },
    createFromStore: {
      type: Boolean,
    },
    subscription: {
      type: Object,
      default: null
    },
    invoice: {
      type: Object,
      default: null,
    },
    donor: {
      type: Number,
    },
  },
  name: "create-collection",
  data() {
    return {
      foundError: false,
      loading: false,
      dialog: false,
      message: null,
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    message: {
      required,
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser", 'currentBusiness']),
    nameErrors() {
      const errors = [];
      if (!this.$v.message.$dirty) return errors;
      if (!this.$v.message.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    createDialog(val) {
      console.log("donor", this.donor);
      if (this.subscription) {
        this.message = `As-Salamu 'Alaykum wa Rahmatullahi wa Barakatuhu, We are contacting you regarding your recent pledge to  ${this.currentBusiness.name}. Please fill in your payment information.`
      }
      this.dialog = val;
    },
  },
  methods: {
    // properCase(string) {
    //   var sentence = string.toLowerCase().split(" ");
    //   for (var i = 0; i < sentence.length; i++) {
    //     sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    //   }
    //   return sentence.join(" ");
    // },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.message = null;
      this.loading = false;
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;

        let paymentObj = {
          DonorId: this.donor,
          message: this.message,
        }
        if(this.subscription){
          paymentObj.SubscriptionId = this.subscription.id
        }

        return paymentService
          .create(paymentObj)
          .then((result) => {
            console.log('result', result)
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Payment Link Created.",
                });
              this.loading = false;
              this.$emit("submit");
              // this.$events.emit("customerListEvent");
              this.close();
            }
          })
          .catch((err) => {
            console.log("err", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
